// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1dujs","footer":"ModalError_footer__bZuj_"};